// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"29d9124e","490":"a0427477","727":"dc65e49c"}[chunkId] + ".chunk.css";
};